export default "__VITE_ASSET__BmG64J8I__"